import { render, staticRenderFns } from "./MrpaEnableAssigneeOrganization.vue?vue&type=template&id=a5803bb0&"
import script from "./MrpaEnableAssigneeOrganization.vue?vue&type=script&lang=js&"
export * from "./MrpaEnableAssigneeOrganization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports